module.exports = __webpack_public_path__ + "media/images/home/nl/preview-6-1351c4021e2173c0566d058162c5c7c6.jpg";